import { Link } from '@iheartjane/reefer';

import styles from './deselectAll.module.css';

type DeselectAllProps = {
  onClick: () => void;
};

export const DeselectAll = ({ onClick }: DeselectAllProps) => (
  <Link ml={8} color="text-main" onClick={onClick} className={styles['text']}>
    Deselect all
  </Link>
);
